import { render, staticRenderFns } from "./tutorial.vue?vue&type=template&id=06b600c6&scoped=true&"
var script = {}
import style0 from "./tutorial.vue?vue&type=style&index=0&id=06b600c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b600c6",
  null
  
)

export default component.exports